import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MarketmanagerSharedModule } from '../../shared';
import {
    MarketdayService,
    MarketdayPopupService,
    MarketdayComponent,
    MarketdayDetailComponent,
    MarketdayDialogComponent,
    MarketdayPopupComponent,
    MarketdayDeletePopupComponent,
    MarketdayDeleteDialogComponent,
    marketdayRoute,
    marketdayPopupRoute,
    MarketdayResolvePagingParams,
} from './';

const ENTITY_STATES = [
    ...marketdayRoute,
    ...marketdayPopupRoute,
];

@NgModule({
    imports: [
        MarketmanagerSharedModule,
        RouterModule.forRoot(ENTITY_STATES, { useHash: true })
    ],
    declarations: [
        MarketdayComponent,
        MarketdayDetailComponent,
        MarketdayDialogComponent,
        MarketdayDeleteDialogComponent,
        MarketdayPopupComponent,
        MarketdayDeletePopupComponent,
    ],
    entryComponents: [
        MarketdayComponent,
        MarketdayDialogComponent,
        MarketdayPopupComponent,
        MarketdayDeleteDialogComponent,
        MarketdayDeletePopupComponent,
    ],
    providers: [
        MarketdayService,
        MarketdayPopupService,
        MarketdayResolvePagingParams,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class MarketmanagerMarketdayModule {}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketday/marketday.module.ts